'use client'

import type { HTMLAttributes } from 'react'

import cn from 'clsx'

import css from './GuideProgressBar.module.css'

export type GuideProgressBarProps = HTMLAttributes<HTMLDivElement> & {
    max?: number
    current: number
    min?: number
    className?: string
}

export function GuideProgressBar({
    min = 0,
    max = 100,
    current,
    className,
    ...rest
}: GuideProgressBarProps) {
    const boundedCurrent = Math.min(Math.max(min, current), max)
    const currentPercentage = Math.floor((boundedCurrent / max) * 100)

    return (
        <div
            className={cn(css.guideprogressbar, className)}
            style={{ ['--guideprogressbarcurrent' as never]: `${currentPercentage}%` }}
            role="progressbar"
            tabIndex={-1}
            aria-valuemin={min}
            aria-valuemax={max}
            aria-valuenow={current}
            {...rest}
        />
    )
}
